import Swal from 'sweetalert2'
import { serialize } from 'object-to-formdata';
import { t } from '@/@core/libs/i18n/utils';

export default class Controller {
  constructor(model) {
    this.model = model
    this.options = {
      indices: true,
      nullsAsUndefineds: false,
      booleansAsIntegers: false,
      allowEmptyArrays: true,
    };
    this.headers = {
      headers: {
        'Content-Type': 'multipart/form-data',
        charset: 'utf-8',
        boundary: Math.random().toString().substr(2),
      },

    }

  }

  async GetAll(params) {
    const data = await this.model.GetAll(params)
    return data
  }

  async Show(id, params) {
    const data = await this.model.Show(id, params)
    return data
  }

  async Insert(data, headers = {}) {
    const res = await this.model.Insert(data, headers)
    return this.Poup(res);
  }

  async From(data, type, returnData = false) {
    console.log(data);
    
    let headers = {}
    let edit = false
    if (data.id) edit = true
    if (type == 'FormData') {
      const formData = serialize(
        data,
        this.options, // optional
      );
      data = formData
    }
    let res = {}

    if (edit) {
      if (type == 'FormData')
        res = await this.model.Updata(data, this.headers)
      else
        res = await this.model.UpdataPut(data, this.headers)
    } else {
      res = await this.model.Insert(data, headers)
    }
    if (returnData) {
      return { status: this.Poup(res), data: res };
    }
    return this.Poup(res);

  }

  async Updata(data, poup = true) {
    const formData = serialize(
      data,
      this.options, // optional
    );
    data = formData
    const res = await this.model.Updata(data)
    if (poup) return this.Poup(res);
  }

  async Delete(id, recordIds = [], table) {
    const result = await Swal.fire({
      position: 'top-start',
      title: 'هل أنت متأكد',

      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'إلغاء',

      confirmButtonColor: '#ce7b2c',
      cancelButtonColor: '#28c76f',
      confirmButtonText: 'نعم ، احذفها!',
    })

    if (result.isConfirmed) {
      const res = await this.model.Delete(id, recordIds)
      this.Poup(res);
      if (table) table.refresh()
    }

    return []
  }
  
  Poup(res) {
    if (res.status) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'تمت العملية بنجاح',
        showConfirmButton: false,
        timer: 3000,
      })
      return [true, res];
    } else {
      Swal.fire({
        position: 'top-start',
        icon: 'error',
        title: 'هناك خطأ',
        text: res.message,
        showConfirmButton: false,
        timer: 3000,
      })
      return false;

    }
  }
}
